// deps
import React, { memo } from "react";

//internal-deps
import { useEffectOnce } from "@swiggy-private/core-ui";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

//styles
import styles from "../SplitPayBanner.scss";

interface Props {
    onClick: VoidFunction;
    onView: VoidFunction;
    disabled: boolean;
    testId: string;
    ctaMessage?: string;
    focusOnMount?: boolean;
}

function AddMoneyButton(props: Props): React.ReactElement | null {
    const { disabled, onClick, onView, ctaMessage } = props;

    useEffectOnce(() => {
        onView();
    });

    return (
        <div className={styles.splitPayAddMoneyBtnContainer}>
            <SuperButton
                autoFocus
                variant="fullwidth"
                buttonType="specialPositive"
                buttonSize="medium"
                onClick={onClick}
                data-testid={props.testId}
                isDisabled={disabled}
                className={styles.splitPayAddMoneyBtn}
            >
                {ctaMessage}
            </SuperButton>
        </div>
    );
}

export default memo(AddMoneyButton);
